import { render, staticRenderFns } from "./inter-iframe.vue?vue&type=template&id=affe413c&"
import script from "./inter-iframe.vue?vue&type=script&lang=js&"
export * from "./inter-iframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports